import AlertDialog from "../components/AlertDialog";
import React, { useState, useEffect } from "react";
import { useNavigate , useLocation } from "react-router-dom";
import { useSelector, useDispatch } from "react-redux";
import { Typography, TextField, Button, Grid, Card } from "@mui/material";
import { api } from "common";
import { useTranslation } from "react-i18next";
import CircularLoading from "components/CircularLoading";
import { colors } from "components/Theme/WebTheme";
import { makeStyles } from "@mui/styles";
import { Autocomplete } from '@mui/material';

const useStyles = makeStyles((theme) => ({
    textField: {
        "& label.Mui-focused": {
            color: colors.MAIN_COLOR,
        },
        "& .MuiInput-underline:after": {
            borderBottomColor: colors.MAIN_COLOR,
        },
        "& .MuiFilledInput-underline:after": {
            borderBottomColor: colors.MAIN_COLOR,
        },
        "& .MuiOutlinedInput-root": {
            "&.Mui-focused fieldset": {
                borderColor: colors.MAIN_COLOR,
            },
        },
    },
    rootRtl: {
        "& label": {
            right: 0,
            left: "auto",
            paddingRight: 20
        },
        "& legend": {
            textAlign: "right",
            marginRight: 37
        },
        "& label.Mui-focused": {
            color: colors.MAIN_COLOR,
        },
        "& .MuiInput-underline:after": {
            borderBottomColor: colors.MAIN_COLOR,
        },
        "& .MuiFilledInput-underline:after": {
            borderBottomColor: colors.MAIN_COLOR,
        },
        "& .MuiOutlinedInput-root": {
            "&.Mui-focused fieldset": {
                borderColor: colors.MAIN_COLOR,
            },
        },
    },
    rootRtl_2: {
        "& label": {
            right: 17,
            left: "auto",
            paddingRight: 12
        },
        "& legend": {
            textAlign: "right",
            marginRight: 25
        },
        "& label.Mui-focused": {
            color: colors.MAIN_COLOR,
        },
        "& .MuiInput-underline:after": {
            borderBottomColor: colors.MAIN_COLOR,
        },
        "& .MuiFilledInput-underline:after": {
            borderBottomColor: colors.MAIN_COLOR,
        },
        "& .MuiOutlinedInput-root": {
            "&.Mui-focused fieldset": {
                borderColor: colors.MAIN_COLOR,
            },
        },
    },
    selectField_rtl_2: {
        color: "black",
        "&.Mui-focused .MuiOutlinedInput-notchedOutline": {
            borderColor: colors.MAIN_COLOR,
        },
        "& label": {
            right: 50,
            left: "auto",
            paddingRight: 12,
        },
        "& legend": {
            textAlign: "right",
            marginRight: 20,
        },
    },
    selectField_rtl_1: {
        color: "black",
        "&.Mui-focused .MuiOutlinedInput-notchedOutline": {
            borderColor: colors.MAIN_COLOR,
        },
        "& label": {
            right: 50,
            left: "auto",
            paddingRight: 12,
        },
        "& legend": {
            textAlign: "right",
            marginRight: 25,
        },
    },

    selectField_rtl: {
        color: "black",
        "&.Mui-focused .MuiOutlinedInput-notchedOutline": {
            borderColor: colors.MAIN_COLOR,
        },
        "& label": {
            right: 50,
            left: "auto",
            paddingRight: 12,
        },
        "& legend": {
            textAlign: "right",
            marginRight: 15,
        },
    },

    right: {
        textAlign: "right",
        right: 0,
        left: "auto",
        paddingRight: 40,
    },
    selectField: {
        color: "black",
        "&.Mui-focused .MuiOutlinedInput-notchedOutline": {
            borderColor: colors.MAIN_COLOR,
        },
    },
}));

const AddCar = () => {
    const { t, i18n } = useTranslation();
    const isRTL = i18n.dir();
    const settings = useSelector((state) => state.settingsdata.settings);
    const auth = useSelector((state) => state.auth);
    const dispatch = useDispatch();
    const navigate = useNavigate();
    const { editCar, updateUserCar } = api;
    const [commonAlert, setCommonAlert] = useState({ open: false, msg: "" });
    const [role, setRole] = useState(null);
    const userdata = useSelector((state) => state.usersdata);
    const [drivers, setDrivers] = useState([]);
    const cartypes = useSelector((state) => state.cartypes);
    const [loding, setLoding] = useState(false);
    const classes = useStyles();
    const categorylistdata = useSelector((state) => state.categorylistdata);
    const [category, setCategory] = useState([]);
    const [selectCategory, setSelectCategory] = useState(null);
    const [selectCartype, setSelectCartype] = useState(null);
    const [carType, setCarType] = useState([]);
    const [driver, setDriver] = useState(null);
    const [fleetMapObj, setFleetMapObj] = useState([]);
    const [capacityValue,setCapacityvalue]=useState("")
    const {state} = useLocation();
    
    const [data, setData] = useState({
        createdAt: new Date().getTime(),
        car_image:
            "https://firebasestorage.googleapis.com/v0/b/sride-777.appspot.com/o/2.png?alt=media&token=b318e5c2-365e-49b5-adb0-60e3da478ec8",
        vehicleNumber: "",
        vehicleMake: "",
        carType: "",
        driver: "",
        vehicleModel: "",
        other_info: "",
        active: false,
    });
    const carlistdata = useSelector((state) => state.carlistdata);
    const [carData, setCardata] = useState();

    useEffect(() => {
        if (role !== 'driver' && userdata.users) {
            let arr = userdata.users.filter(user => user.usertype === 'driver' && ((role === 'fleetadmin' && user.fleetadmin && user.fleetadmin === auth.profile.uid) || role === 'admin'|| role === 'subadmin' ));
            let obj = {};
            let obj2 = {};
            let arr2 = [];
            for (let i = 0; i < arr.length; i++) {
                let user = arr[i];
                arr2.push({ id: user.id, desc: user.firstName + ' ' + user.lastName + ' (' + (settings.AllowCriticalEditsAdmin ? user.mobile : "Hidden") + ') ' + (settings.AllowCriticalEditsAdmin ? user.email : "Hidden") });
                obj[user.id] = user.firstName + ' ' + user.lastName + ' (' + (settings.AllowCriticalEditsAdmin ? user.mobile : "Hidden") + ') ' + (settings.AllowCriticalEditsAdmin ? user.email : "Hidden");
                obj2[user.id] = user.fleetadmin ? user.fleetadmin : null
            }
            setDrivers(arr2);
            setFleetMapObj(obj2);
        }
    }, [userdata.users, settings.AllowCriticalEditsAdmin, role, auth.profile.uid]);

    useEffect(() => {
        if (categorylistdata.categories && categorylistdata.categories.length > 1) {
            let lst = categorylistdata.categories;
            let arr = [];
            for (let i = 0; i < lst.length; i++) {
                if (lst[i].active) {
                    arr.push({ label: t(lst[i].category), value: lst[i].category });
                }
            }
            setCategory(arr);
        }
    }, [categorylistdata.categories, selectCategory, t]);
    


    useEffect(() => {
        if (auth.profile && auth.profile.usertype) {
            setRole(auth.profile.usertype);
        }
    }, [auth.profile]);

    useEffect(() => {
        if (carlistdata.cars) {
            setCardata(carlistdata.cars);
        } else {
            setCardata([]);
        }
    }, [carlistdata.cars]);
    const handleCommonAlertClose = (e) => {
        e.preventDefault();
        setCommonAlert({ open: false, msg: "" });
    };
    const handelchangeDriver = (event, newValue) => {
        setDriver(newValue)
    }
    const handleInputChange = (e) => {
        setData({ ...data, [e.target.id]: e.target.value });
    };

    const handelchangeCartype = (event, newValue) => {
        setSelectCartype(newValue)
    }

    const isOptionEqualToValue = (option, value) => option.value === value.value;


    const handleChangeCategory = (event, newValue) => {
        setSelectCategory(newValue);
        setSelectCartype(null);
        if (newValue) {
            const filteredCarTypes = cartypes.cars.filter(car => car.category === newValue.value)
                .map(car => ({ label: car.name, value: car.name, capacity:car.capacity ? car.capacity : 0 , unit_type:car.unit_type?car.unit_type:'', activeCar_position: car.capacity ? car.capacity : 0}));
            setCarType(filteredCarTypes);
        } else {
            setCarType([]);
        }
    };

    useEffect(() => {
        const capacity_value = `${selectCartype?.capacity || ''} ${selectCartype?.unit_type || ''}`;
        setCapacityvalue(capacity_value.trim()); 
      }, [selectCartype]);
      

    const handelSubmit = () => {
        settings.AllowCriticalEditsAdmin ?
            new Promise((resolve, reject) => {
                setLoding(true);
                setTimeout(() => {
                    if (data && selectCartype && selectCartype.value && selectCategory && selectCategory.value && data.vehicleNumber && data.vehicleMake && data.vehicleModel && (driver ? driver : auth.profile.uid)) {
                        let selectDriver = role === 'admin' || role === 'subadmin' || role === 'fleetadmin' ? driver?.id : auth.profile.uid;
                        let activeCar = null;
                        if(selectDriver){
                        let updateData = {
                            carType: selectCartype.value,
                            category: selectCategory.value,
                            vehicleNumber: data.vehicleNumber,
                            vehicleMake: data.vehicleMake,
                            vehicleModel: data.vehicleModel,
                            car_image: data.car_image,
                            other_info: data.other_info ? data.other_info : "",
                            createdAt: new Date().getTime(),
                            driver: selectDriver,
                            capacity:selectCartype.capacity,
                            unit_type:selectCartype.unit_type?selectCartype.unit_type:"",
                            activeCar_position:selectCartype.activeCar_position,
                            fleetadmin: role === 'fleetadmin' ? auth.profile.uid : selectDriver ? (fleetMapObj[selectDriver] ? fleetMapObj[selectDriver] : null) : null
                        }
                        for (let i = 0; i < carData.length; i++) {
                            if (carData[i].driver === selectDriver && carData[i].active) {
                                activeCar = carData[i];
                                break;
                            }
                        }
                        if (activeCar && data.active) {
                            activeCar.active = false;
                            dispatch(editCar(activeCar, "Update"));
                            delete updateData.createdAt;
                            dispatch(updateUserCar(selectDriver, updateData));
                        } else if (activeCar && !data.active) {
                            data.active = false;
                        } else {
                            data.active = true;
                            delete updateData.createdAt;
                            dispatch(updateUserCar(selectDriver, updateData));
                        }
                        if (role === 'driver') {
                            data['driver'] = selectDriver;
                        }
                        if (!settings.carApproval) {
                            data['approved'] = true;
                            if (data.active) {
                                dispatch(updateUserCar(selectDriver, { carApproved: true }));
                            }
                        } else {
                            data['approved'] = false;
                        }
                        
                        let updateCaeData = {
                            ...updateData,
                            active: data.active,
                            approved: data.approved,
                            createdAt: new Date().getTime(),
                        }
                        dispatch(editCar(updateCaeData, "Add"));
                        setSelectCategory();
                        setDriver();
                        setSelectCartype();
                        setLoding(false);
                        navigate("/cars");
                        resolve();
                    }else{
                        setCommonAlert({ open: true, msg: t('no_details_error') });
                        setLoding(false);
                        reject();
                    }
                    } else {
                        setCommonAlert({ open: true, msg: t('no_details_error') });
                        setLoding(false);
                        reject();
                    }
                }, 600);
            })
            :
            new Promise(resolve => {
                setTimeout(() => {
                    resolve();
                    setLoding(false)
                    setCommonAlert({ open: true, msg: t('demo_mode') });
                }, 600);
            })

    };

    return loding ? (
        <CircularLoading />
    ) : (
        <div>
            <Card
                style={{
                    borderRadius: "19px",
                    backgroundColor: colors.WHITE,
                    minHeight: 100,
                    maxWidth: "75vw",
                    marginTop: 20,
                    marginBottom: 20,
                    padding: 25,
                    alignItems: "center",
                    justifyContent: "center",
                    boxShadow: `0px 2px 5px ${colors.SECONDARY}`,
                }}
            >
                <Typography
                    variant="h5"
                    style={{
                        marginTop: -15,
                        textAlign: isRTL === "rtl" ? "right" : "left",
                    }}
                >
                    {t("add_car_title")}
                </Typography>
                <div
                    dir={isRTL === "rtl" ? "rtl" : "ltr"}
                >
                    <Button
                        variant="text"
                        onClick={() => {
                            navigate('/cars', 
            { state: { pageNo: state?.pageNo }} )
                        }}
                    >
                        <Typography
                            style={{
                                marginBottom: 10,
                                textAlign: isRTL === "rtl" ? "right" : "left",
                                fontWeight: "bold",
                                color: colors.MAIN_COLOR
                            }}
                        >
                            {`<<- ${t("go_back")}`}
                        </Typography>
                    </Button>
                </div>
                <Grid
                    container
                    spacing={2}
                    sx={{
                        direction: isRTL === "rtl" ? "rtl" : "ltr",
                        gridTemplateColumns: "50%",
                    }}
                >
                    <Grid item xs={12} sm={12} md={12} lg={6} xl={6}>
                        <TextField
                            label={t("vehicle_reg_no")}
                            id={"vehicleNumber"}
                            value={data?.vehicleNumber}
                            fullWidth
                            onChange={handleInputChange}
                            className={isRTL === "rtl" ? classes.rootRtl_2 : classes.textField}
                        />
                    </Grid>
                    <Grid item xs={12} sm={12} md={12} lg={6} xl={6}>
                        <TextField
                            label={t("vehicle_model_name")}
                            id={"vehicleMake"}
                            value={data?.vehicleMake}
                            fullWidth
                            onChange={handleInputChange}
                            className={isRTL === "rtl" ? classes.rootRtl : classes.textField}
                        />
                    </Grid>
                    <Grid item xs={12} sm={12} md={12} lg={6} xl={6}>
                        <TextField
                            label={t("vehicle_model_no")}
                            id={"vehicleModel"}
                            value={data?.vehicleModel}
                            fullWidth
                            onChange={handleInputChange}
                            className={isRTL === "rtl" ? classes.rootRtl_2 : classes.textField}
                        />
                    </Grid>
                    <Grid item xs={12} sm={12} md={12} lg={6} xl={6}>
                        <TextField
                            label={t("other_info")}
                            id={"other_info"}
                            value={data?.other_info}
                            fullWidth
                            onChange={handleInputChange}
                            className={isRTL === "rtl" ? classes.rootRtl : classes.textField}
                        />
                    </Grid>
                   
                    <Grid
            item
            xs={12}
            sm={12}
            md={12}
            lg={6}
            xl={6}
            style={{
                display: "flex",
                justifyContent: "center",
                alignItems: "center",
            }}
        >
            <Autocomplete
                disablePortal
                id="combo-box-demo"
                options={category}
                sx={{ width: "100%" }}
                renderInput={(params) => <TextField {...params} label={t('category')} className={isRTL === "rtl" ? classes.rootRtl : classes.textField} />}
                onChange={handleChangeCategory}
                disableClearable={true}
                value={selectCategory}
                isOptionEqualToValue={isOptionEqualToValue}
            />
        </Grid>
                    <Grid
                        item
                        xs={12}
                        sm={12}
                        md={12}
                        lg={6}
                        xl={6}
                        style={{
                            display: "flex",
                            justifyContent: "center",
                            alignItems: "center",
                        }}
                    >
                        <Autocomplete
                            disablePortal
                            id="combo-box-demo"
                            options={carType}
                            sx={{ width: "100%" }}
                            renderInput={(params) => <TextField {...params} label={t('cartype')} className={isRTL === "rtl" ? classes.rootRtl : classes.textField}/>}
                            onChange={handelchangeCartype}
                            disableClearable={true}
                            value={selectCartype}
                        />
                    </Grid>
                    
                        <Grid
                            item
                            xs={12}
                            sm={12}
                            md={12}
                            lg={6}
                            xl={6}
                            style={{
                                display: "flex",
                                justifyContent: "center",
                                alignItems: "center",
                            }}
                        >
                             <TextField label={t('carcapacity')} 
                             value={capacityValue} 
                             sx={{ width: "100%" }} 
                             className={isRTL === "rtl" ? classes.rootRtl : classes.textField}
                             disabled 
                             />
                        </Grid>

                    {role ==='driver'?null:<Grid
                        item
                        xs={12}
                        sm={12}
                        md={12}
                        lg={6}
                        xl={6}
                        style={{
                            display: "flex",
                            justifyContent: "center",
                            alignItems: "center",
                        }}
                    >
                        <Autocomplete
                            id="combo-box-demo"
                            options={drivers}
                            getOptionLabel={(option) => option.desc}
                            style={{ width: "100%" }}
                            renderInput={(params) => <TextField {...params} label={t('drivers')} variant="outlined" className={isRTL === "rtl" ? classes.rootRtl : classes.textField} />}
                            onChange={handelchangeDriver}
                            disableClearable={true}
                            value={driver}
                        />
                    </Grid>}
                    
                    <Grid item xs={12} sm={12} md={12} lg={12} xl={12}
                         sx={{ display: "flex", justifyContent: "center", alignItems: "center" }}
                    >
                        <Button
                            style={{
                                borderRadius: "19px",
                                backgroundColor: colors.MAIN_COLOR,
                                minHeight: 50,
                                minWidth: "50%",
                                textAlign: "center"
                            }}
                            onClick={handelSubmit}
                            variant="contained"
                        >
                            <Typography
                                style={{
                                    color: colors.WHITE,
                                    textAlign: "center",
                                    fontSize: 16,
                                    fontWeight: "bold"
                                }}
                            >
                                {t("submit")}
                            </Typography>
                        </Button>
                    </Grid>
                </Grid>
            </Card>
            <AlertDialog open={commonAlert.open} onClose={handleCommonAlertClose}>
                {commonAlert.msg}
            </AlertDialog>
        </div>
    );
};

export default AddCar;
